"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _comparisonActions = require("../../store/comparison/comparisonActions");
var _comparisonSelectors = require("../../store/comparison/comparisonSelectors");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _upsellActions = require("../../store/upsell/upsellActions");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useComparison = () => {
  const {
    showComparisonForDevices
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectComparisonSettings);
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const products = (0, _useAppSelector.useAppSelector)(_comparisonSelectors.selectComparableProductsList);
  const displayedProducts = (0, _useAppSelector.useAppSelector)(_comparisonSelectors.selectDisplayedProducts);
  const showDevices = (0, _useAppSelector.useAppSelector)(_comparisonSelectors.selectShowDevices);
  const showPlans = (0, _useAppSelector.useAppSelector)(_comparisonSelectors.selectShowPlans);
  const showBusinessSolution = (0, _useAppSelector.useAppSelector)(_comparisonSelectors.selectShowBusinessSolutions);
  const onProductSelect = productId => {
    if (products[productId].productType === 'handset') {
      dispatch((0, _recommendationActions.updateSelectedHandset)(productId));
    } else if (products[productId].productType === 'plan') {
      dispatch((0, _recommendationActions.updateSelectedPlan)(productId));
    } else if (products[productId].productType === 'business-solution') {
      dispatch((0, _recommendationActions.updateSelectedBusinessSolution)(productId));
    } else {
      dispatch((0, _recommendationActions.updateSelectedBroadband)(productId));
    }
    dispatch((0, _upsellActions.goBackToRecommendation)());
  };
  //Extrapolate the category of products to show based on journey.

  const notSelectedProducts = Object.values(products).filter(product => {
    return !displayedProducts.includes(product.productId);
  });
  const updateCurrentSelectedProducts = (previousId, newId) => {
    dispatch((0, _comparisonActions.updateDisplayedProduct)(previousId, newId));
  };
  return {
    showComparisonDevices: showComparisonForDevices,
    products,
    displayedProducts,
    updateCurrentSelectedProducts,
    showDevices,
    showPlans,
    showBusinessSolution,
    onProductSelect,
    notSelectedProducts
  };
};
var _default = useComparison;
exports.default = _default;